export default __webpack_public_path__ + "assets/images/3186d4a7c48f8ff0bef743855ba5033e.png";